<template>
  <div class="bodyBox">

<!--    背景图-->
    <div class="bodyBox-img">
        <!-- <img src="../../../assets/image/Group.png" alt="" class="img"> -->
    </div>

<!--    标题-->
    <div class="content-box">

      <!-- 指南 -->
      <div class="guide">
        <div class="textT">点击左侧活动中心发布活动 。 点击查看</div>
        <div class="caozuo">
          <a href="https://www.yuque.com/g/sanjingshou-rnn99/ooit4a/sl4cfsxluvigvv8h/collaborator/join?token=XrBaEPyRUTWgcSYy#" target="blank">《协会操作指南》</a>
        </div>
        <div class="jishu">，技术服务电话: 0577-88343133(工作日9:00-17:30)</div>
      </div>

      <div class="content">
        <div class="title">欢迎回来，{{ Title.org_com }}</div>
      </div>

      <div class="reveal">
        <div class="gaine" v-for="(item,index) in List" :key="index">
          <div class="gaineCenter">
            <div class="gaineImg">
              <img :src="item.imgUrl" alt="">
            </div>
            <div class="gaineCharacters">{{ item.name }}</div>
            <div class="gaineNumber">{{item.now}}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {businessStatistics} from '@/api/zhanghaoguanli'
import {shangxiehuixiangqing} from '@/api/shangxiehui'
export default {
  data(){
    return{
      List:[],
      Title:{},
      icon:[],

      imgUrl:[
        {
          icon:"bus",
          imgUrl:require("../../../assets/image/Frame.png"),
        },
        {
          icon:"member",
          imgUrl:require("../../../assets/image/FrameTou.png"),
        },
        {
          icon:"saishi",
          imgUrl:require("../../../assets/image/Frametrophy.png"),
        },
        {
          icon:"dangjian",
          imgUrl:require("../../../assets/image/partybuilding.png"),
        },
        {
          icon:"peixun",
          imgUrl:require("../../../assets/image/train.png"),
        },
        {
          icon:"huodong",
          imgUrl:require("../../../assets/image/Numberofassociations.png"),
        },
        {
          icon:"xiehui",
          imgUrl:require("../../../assets/image/Numberofassociations.png"),
        },
        {
          icon:"policy",
          imgUrl:require("../../../assets/image/Numberofassociations.png"),
        }
      ]
    }
  },

  created(){
    this.xiangqing()
  },

  methods:{
    xiangqing(){
      const obj = {
        token : sessionStorage.getItem('token')
      }
      businessStatistics(obj).then(({data:res})=>{
        if(res.result===1){
          this.List=res.list
          console.log("输出",res.list);
          // 匹配icon
          this.imgUrl.forEach(item=>{
            for(var i=0; i<res.list.length; i++){
              // console.log("遍历的数组",res.list[i]);
              if(res.list[i].icon==item.icon){
                this.List[i].imgUrl=item.imgUrl
              }
            }
        })
        console.log(this.List);
        }
      })

      shangxiehuixiangqing(obj).then(({data:res})=>{
        if(res.result===1){
          this.Title=res
        }
      })
    }
  },

}
</script>

<style scoped lang="less">
.body{
  margin-left: -20px;
  margin-top: -20px;

}
::v-deep .el-main{
  padding: 0 !important;
}
.bodyBox{
  height: 843px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .bodyBox-img{
    width: 100%;
    height: 850px;
    .img{
      width: 100%;
      height: 863px;
      background-repeat: no-repeat;
      vertical-align: middle;
    }
  }

  .content-box{
    width: 100%;
    height: 100%;
    position: absolute;

    .guide{
      height: 30px;
      background: linear-gradient(90deg,rgba(255,255,255,0.00) 20%, rgba(255,255,255,0.70) 100%, rgba(255,255,255,0.00) 100%);
      border-radius: 12px;
      backdrop-filter: blur(6.5px);
      display: flex;
      align-items: center;
      margin-top: 20px;

      .textT{
        font-size: 18px;
        font-family: PingFang HK, PingFang HK-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #666;
        line-height: 30px;
        padding-left: 30px;
      }

      .caozuo{
        font-size: 18px;
        font-family: PingFang HK, PingFang HK-Regular;
        font-weight: 400;
        text-align: CENTER;
        line-height: 30px;

        a{
          text-decoration: none;
          color: #589FF8;
        }
      }
      .jishu{
        font-size: 18px;
        font-family: PingFang HK, PingFang HK-Regular;
        font-weight: 400;
        text-align: CENTER;
        color: #666;
        line-height: 30px;
      }
    }
  }

  .content{
    height: 56px;

    .title{
      font-size: 30px;
      font-family: Roboto-SemiBold, Roboto;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      padding-left: 30px;
    }
  }
  .reveal{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 10px;

    .gaine{
      width: 230px;
      height: 270px;
      border-radius: 12px;
      backdrop-filter: blur(6.5px);
      margin-bottom: 30px;
      margin-left: 30px;
      background: linear-gradient(143.57deg, rgba(232, 252, 254, 0.7) 0%, rgba(216, 235, 251, 0.7) 39.36%, rgba(239, 238, 251, 0.7) 107.97%);

      .gaineCenter{
        width: 172px;
        height: 290px;
        margin: auto;
        margin-top: 11px;

        .gaineImg{
          width: 109px;
          height: 109px;
          border-radius: 77px;
          margin-left: 35px;
          padding-top: 11px;

          .imgUrl{
            width: 109px;
            height: 109px;
          }
        }

        .gaineCharacters{
          height: 27px;
          margin-top: 30px;
          text-align: center;
          color: #666666;
          font-size: 22px;
        }

        .gaineNumber{
          height: 75px;
          margin: auto;
          font-size: 40px;
          font-family: Roboto, Roboto-SemiBold;
          font-weight: normal;
          text-align: center;
          color: #333333;
          line-height: 75px;
        }
      }
    }
  }
}

</style>
